import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  glass: {
    background: 'rgba(255,255,255,0.75)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(0,0,0,0.07)',
    borderRadius: 12,
    boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
    overflow: 'hidden',
  },
  accent: {
    borderTop: '2px solid #3b82f6',
    borderLeft: '1px solid rgba(59,130,246,0.2)',
  },
  elevated: {
    boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
  },
  flat: {
    boxShadow: 'none',
    border: '1px solid rgba(0,0,0,0.07)',
  },
  noPad: {
    padding: 0,
  },
  pad: {
    padding: 16,
  },
  padLg: {
    padding: 24,
  },
}));

function GlassCard({ children, className, accent, elevated, flat, padding = 'none', style, ...rest }) {
  const classes = useStyles();
  const padClass = padding === 'sm' ? classes.pad : padding === 'lg' ? classes.padLg : classes.noPad;
  return (
    <div
      className={clsx(classes.glass, padClass, {
        [classes.accent]: accent,
        [classes.elevated]: elevated,
        [classes.flat]: flat,
      }, className)}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
}

export default GlassCard;
